export default __webpack_public_path__ + "static/media/Vector2.1.fc0c7bc1.png";